<div class="charge-labor">

  <p-dropdown [placeholder]="PrimeNgConfig.DropdownPlaceholder" styleClass="charge-dropdown"
              [options]="chargeCodeDropdown" filter="true"
              [(ngModel)]="selectedChargeCode"
              (onChange)="onSelectChargeCode(selectedChargeCode, txnType)">
  </p-dropdown>
  <button *ngIf="selectedChargeCode"
          pButton type="button" class="icon-action charge-info" icon="fa fa-info-circle" (click)="ccOverlay.show($event)" (mouseenter)="ccOverlay.toggle($event)"></button>
  <div *ngIf="chargeCode&&chargeCode.id&&!chargeCodeFound&&!loading" class="alert alert-danger">
    {{ chargeCode?.chargeNumber }} is no longer valid for the user.
  </div>
  <div *ngIf="chargeCodeId&&!chargeCodeFound&&!loading" class="alert alert-danger">
    {{ chargeNumber }} is no longer valid for the user.
  </div>

  <p-dropdown *ngIf="laborCategoryDropdown&&laborCategoryDropdown.length>0"
              [placeholder]="PrimeNgConfig.DropdownPlaceholder" styleClass="labor-dropdown"
              [options]="laborCategoryDropdown"
              [(ngModel)]="selectedLaborCategory"
              (onChange)="onSelectLaborCategory(selectedLaborCategory)">
    <ng-template let-laborCategory pTemplate="selectedItem">
      {{laborCategory?.value?.laborCategoryCode}}
    </ng-template>
    <ng-template let-laborCategory pTemplate="item">
      <div *ngFor="let property of laborCategoryDisplayProperties; let i = index">
        {{laborCategory?.value[property]}}
      </div>
    </ng-template>
  </p-dropdown>
  <div *ngIf="chargeCodeId&&!laborCategoryFound&&!loading" class="alert alert-danger">
    Selected labor category is no longer valid for the user. Please select a valid labor category code.
  </div>


  <p-dropdown *ngIf="workLocationDropdown&&workLocationDropdown.length>0"
              [placeholder]="PrimeNgConfig.DropdownPlaceholder" styleClass="location-dropdown"
              [options]="workLocationDropdown" [filter]="true"
              [(ngModel)]="selectedWorkLocation"
              (onChange)="onSelectWorkLocation(selectedWorkLocation)">

  </p-dropdown>
  <div *ngIf="chargeCodeId&&!workLocationFound&&!loading" class="alert alert-danger">
    Selected work location is no longer valid for the user. Please select a valid work location.
  </div>
</div>

<p-overlayPanel [style]="{'width':'400px'}" #ccOverlay appendTo="body" [showCloseIcon]="true">
  <table *ngIf="selectedChargeCode" class="table table-striped" style="width: 400px">
    <tbody>
    <tr>
      <td> Charge Code</td>
      <td> {{selectedChargeCode?.chargeNumber}} </td>
    </tr>
    <tr>
      <td> Charge Code Type</td>
      <td> {{selectedChargeCode?.codeType}} </td>
    </tr>
    <tr *ngIf="!selectedLaborCategory">
      <td> Authorized Dates</td>
      <td> {{selectedChargeCode?.authorizedFrom}} ~ {{selectedChargeCode?.authorizedThru}} </td>
    </tr>
    <tr *ngIf="selectedChargeCode.projectName">
      <td> Project</td>
      <td> {{selectedChargeCode?.projectName}}</td>
    </tr>
    <tr *ngIf="selectedChargeCode.taskName">
      <td> Task</td>
      <td> {{selectedChargeCode?.taskName}}</td>
    </tr>
    <tr *ngIf="selectedChargeCode">
      <td> Authorized Hours</td>
      <td> {{selectedChargeCode?.authorizedHours}}</td>
    </tr>
    <tr *ngIf="selectedChargeCode">
      <td> Hours Worked</td>
      <td> {{selectedChargeCode?.workedHours}}</td>
    </tr>
    <tr *ngIf="selectedLaborCategory">
      <td> Labor Category</td>
      <td> {{selectedLaborCategory?.laborCategoryCode}}</td>
    </tr>
    <tr *ngIf="selectedLaborCategory">
      <td> Authorized Hours for Labor Category</td>
      <td> {{selectedLaborCategory?.authorizedHours}}</td>
    </tr>
    <tr *ngIf="selectedLaborCategory">
      <td> Hours Worked for Labor Category</td>
      <td> {{selectedLaborCategory?.actualHours}}</td>
    </tr>
    <tr *ngIf="selectedLaborCategory">
      <td> Authorized Dates</td>
      <td> {{selectedLaborCategory?.authorizedFrom}} ~ {{selectedLaborCategory?.authorizedThru}}</td>
    </tr>
    <tr *ngIf="selectedChargeCode.payTypeCode">
      <td> Pay Type</td>
      <td> {{selectedChargeCode?.payTypeCode}}</td>
    </tr>
    <tr *ngIf="selectedChargeCode?.laborAccountGroupName">
      <td> Labor Account Group</td>
      <td> {{selectedChargeCode?.laborAccountGroupName}}</td>
    </tr>
    <tr *ngIf="selectedChargeCode?.expenseAccountGroupName">
      <td> Expense Account Group</td>
      <td> {{selectedChargeCode?.expenseAccountGroupName}}</td>
    </tr>
    <tr *ngIf="selectedChargeCode?.purchaseAccountGroupName">
      <td> Purchase Account Group</td>
      <td> {{selectedChargeCode?.purchaseAccountGroupName}}</td>
    </tr>
    </tbody>
  </table>
</p-overlayPanel>
